var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_11226_8660)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "exit_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99984 2C8.16976 2.00019 8.33319 2.06525 8.45675 2.1819C8.58031 2.29855 8.65466 2.45797 8.66462 2.6276C8.67458 2.79722 8.61939 2.96425 8.51033 3.09455C8.40127 3.22486 8.24657 3.3086 8.07784 3.32867L7.99984 3.33333H4.6665C4.50322 3.33335 4.34561 3.3933 4.22359 3.50181C4.10157 3.61032 4.02361 3.75983 4.0045 3.922L3.99984 4V12C3.99986 12.1633 4.05981 12.3209 4.16831 12.4429C4.27682 12.5649 4.42634 12.6429 4.5885 12.662L4.6665 12.6667H7.6665C7.83642 12.6669 7.99986 12.7319 8.12342 12.8486C8.24697 12.9652 8.32133 13.1246 8.33129 13.2943C8.34124 13.4639 8.28605 13.6309 8.17699 13.7612C8.06793 13.8915 7.91323 13.9753 7.7445 13.9953L7.6665 14H4.6665C4.15636 14 3.66549 13.8051 3.29433 13.4551C2.92317 13.1052 2.69977 12.6266 2.66984 12.1173L2.6665 12V4C2.66648 3.48986 2.86139 2.99899 3.21136 2.62783C3.56133 2.25666 4.03991 2.03326 4.54917 2.00333L4.6665 2H7.99984ZM11.8045 5.64267L13.6898 7.52867C13.8148 7.65369 13.885 7.82322 13.885 8C13.885 8.17678 13.8148 8.34631 13.6898 8.47133L11.8045 10.3573C11.6794 10.4823 11.5098 10.5525 11.3329 10.5525C11.1561 10.5524 10.9865 10.4821 10.8615 10.357C10.7365 10.2319 10.6663 10.0623 10.6664 9.88543C10.6664 9.70858 10.7367 9.53901 10.8618 9.414L11.6092 8.66667H7.99984C7.82303 8.66667 7.65346 8.59643 7.52843 8.4714C7.40341 8.34638 7.33317 8.17681 7.33317 8C7.33317 7.82319 7.40341 7.65362 7.52843 7.5286C7.65346 7.40357 7.82303 7.33333 7.99984 7.33333H11.6092L10.8618 6.586C10.7367 6.46099 10.6664 6.29142 10.6664 6.11457C10.6663 5.93772 10.7365 5.76809 10.8615 5.643C10.9865 5.51791 11.1561 5.44759 11.3329 5.44753C11.5098 5.44747 11.6794 5.51766 11.8045 5.64267Z",
    fill: "#C6F0ED"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11226_8660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout);
export default __webpack_public_path__ + "static/media/checkout.58e1a7ef56d3ebb2c0357b3f2ed22dec.svg";
export { ForwardRef as ReactComponent };